import React from 'react';
import PartnerSection from 'components/PartnerSection';
import { IPartnerContainer } from 'utils/types';

export const PartnerContainer: React.FC<IPartnerContainer> = ({ content }) => {
  if (!content) {
    return null;
  }
  const { title, headline, backgroundColor, slug, cta } = content;

  const ctaContent = cta && {
    text: cta.text,
    url: cta.url,
  };

  return (
    <PartnerSection
      testId="partner-section"
      title={title}
      headline={headline}
      backgroundColor={backgroundColor}
      slug={slug}
      cta={ctaContent}
    />
  );
};

export default PartnerContainer;
